import { render, staticRenderFns } from "./Mainframe.vue?vue&type=template&id=258dc098"
import script from "./Mainframe.vue?vue&type=script&lang=ts"
export * from "./Mainframe.vue?vue&type=script&lang=ts"
import style0 from "./Mainframe.vue?vue&type=style&index=0&id=258dc098&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports